(() => {
  'use strict';
  const configElement = document.getElementById('vibead-membership-config');
  if (!configElement || window.VibeadMembership) return;
  const config = JSON.parse(configElement.textContent);
  const knownVariants = new Set(config.variantIds.map(String));
  const dialog = document.getElementById('vibead-membership-dialog');
  let opener = null;
  let checkoutPending = false;

  function failure(code) {
    const error = new Error(config.messages[code] || config.messages.error);
    error.membershipCode = code;
    return error;
  }

  function report(error) {
    opener = document.activeElement;
    const code = error.membershipCode || 'error';
    document.getElementById('vibead-membership-title').textContent = config.titles[code] || config.titles.error;
    document.getElementById('vibead-membership-message').textContent = config.messages[code] || config.messages.error;
    document.getElementById('vibead-membership-close').textContent = code.startsWith('add_') ? config.closeAdd : config.closeCart;
    if (!dialog.open) dialog.showModal();
  }

  document.getElementById('vibead-membership-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { if (opener?.isConnected) opener.focus(); });

  async function readState() {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 10000);
    try {
      const response = await fetch(config.checkUrl, {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal
      });
      const state = await response.json();
      if (!response.ok || typeof state.wholesale !== 'boolean' || typeof state.mixedMembership !== 'boolean' ||
          !Number.isInteger(state.membershipQuantity) || state.membershipQuantity < 0 ||
          !Array.isArray(state.membershipKeys) || !Array.isArray(state.variantIds) ||
          !Array.isArray(state.cart?.items) || !Number.isInteger(state.cart.total_price) ||
          state.cart.items.some(item => !Number.isInteger(item.quantity) || item.quantity < 0)) {
        throw failure('error');
      }
      state.variantIds.forEach(id => knownVariants.add(String(id)));
      return state;
    } catch (_) {
      throw failure('error');
    } finally {
      clearTimeout(timer);
    }
  }

  function membershipCount(items) {
    return items.reduce((total, item) => {
      const quantity = Number(item.quantity ?? 1);
      if (!Number.isInteger(quantity) || quantity < 0) throw failure('error');
      return total + (knownVariants.has(String(item.id ?? item.variant_id)) ? quantity : 0);
    }, 0);
  }

  function assertQuantity(state, quantity) {
    if (quantity > 0 && state.wholesale) throw failure('wholesale');
    if (quantity > 1) throw failure('quantity');
  }

  function assertCompatible(state, items, remainingItems) {
    const addedMembership = membershipCount(items);
    const remainingMembership = remainingItems.reduce((total, item) =>
      total + (state.membershipKeys.includes(item.key) ? item.quantity : 0), 0);
    const addedOther = items.some(item => Number(item.quantity ?? 1) > 0 &&
      !knownVariants.has(String(item.id ?? item.variant_id)));
    const remainingOther = remainingItems.some(item => item.quantity > 0 && !state.membershipKeys.includes(item.key));
    assertQuantity(state, remainingMembership + addedMembership);
    if (config.warnOnAdd === false) return;
    if (addedMembership > 0 && addedOther) throw failure('add_mixed');
    if (addedMembership > 0 && remainingOther) throw failure('add_membership');
    if (addedOther && remainingMembership > 0) throw failure('add_products');
  }

  async function checkAddition(items) {
    const state = await readState();
    assertCompatible(state, items, state.cart.items);
  }

  async function checkReplacement(items, removedKey) {
    const state = await readState();
    const remainingItems = removedKey ? state.cart.items.filter(item => item.key !== removedKey) : [];
    assertCompatible(state, items, remainingItems);
  }

  async function checkChange(key, quantity) {
    if (Number(quantity) === 0) return;
    const state = await readState();
    if (!state.membershipKeys.includes(key)) return;
    const item = state.cart.items.find(line => line.key === key);
    if (!item) throw failure('error');
    if (Number(quantity) <= item.quantity) return;
    assertQuantity(state, state.membershipQuantity - item.quantity + Number(quantity));
  }

  function add(items, task) {
    return window.Shopify.queueCartMutation(async () => {
      await checkAddition(items);
      return task();
    });
  }

  async function checkout() {
    await window.Shopify.whenCartChangesComplete();
    const state = await readState();
    assertQuantity(state, state.membershipQuantity);
    if (state.mixedMembership) throw failure('mixed');
    return state;
  }

  window.VibeadMembership = { add, checkAddition, checkReplacement, checkChange, checkout, report };

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-vibead-checkout]');
    if (!button || button.disabled) return;
    event.preventDefault();
    if (checkoutPending) return;
    checkoutPending = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await checkout();
      if (window.BeadBucks) await window.BeadBucks.prepareCheckout(document.getElementById('coupon-code')?.value || '');
      window.location.assign(button.dataset.vibeadCheckout);
    } catch (error) {
      if (!error.beadBucks) report(error);
    } finally {
      checkoutPending = false;
      button.removeAttribute('aria-busy');
    }
  });

  document.addEventListener('submit', event => {
    const form = event.target;
    if (event.defaultPrevented || !(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const data = new FormData(form);
    const items = [{ id: data.get('id'), quantity: data.get('quantity') || 1 }];
    event.preventDefault();
    if (form.dataset.vibeadPending) return;
    form.dataset.vibeadPending = 'true';
    add(items, () => HTMLFormElement.prototype.submit.call(form)).catch(error => {
      delete form.dataset.vibeadPending;
      report(error);
    });
  });
})();

